import { neptuneSupervisor } from 'apis/neptune-supervisor';
import { ConfigurationParameters } from 'generated/backend-client';

import { connectivityService } from '@neptune/shared/core-connection-domain';

import {
  appendClientMetadataMiddlewareFactory,
  deferredClientMetadataWrapperResolver,
} from './append-client-metadata-middleware-factory';
import { getBasePath } from './getBasePath';
import { requestTimingMiddleware } from './request-timing-middleware';
import { responseErrorMiddleware } from './response-error-middleware';
import { updateTokenMiddleware } from './update-token-middleware';

export const defaultApiClientConfiguration: ConfigurationParameters = {
  basePath: getBasePath(),
  middleware: [
    requestTimingMiddleware,
    appendClientMetadataMiddlewareFactory(deferredClientMetadataWrapperResolver), // for router metadata injected elsewhere
    connectivityService.asOpenApiMiddleware(),
    neptuneSupervisor.asOpenApiMiddleware(),
    updateTokenMiddleware,
    responseErrorMiddleware,
  ],
};
